import React from "react";
import Export from "../components/Contact/export-enquiry"; 
// import Banner from '../comman/Banner/Banner';


const Exportenquire = () => {
  return (
    <>
    {/* <Banner 
     index={'contact'}
    /> */}
    <Export/>    
    </>

  )
};

export default Exportenquire;